import { BaseModel } from 'app/core/models/base.model';
import { Shipment } from '../shipment/shipment';
import { Status } from 'app/status/status';

export class ShipmentStage extends BaseModel {
	description: string;
	shipment: Shipment;
	statusShipment: Status;
}
